import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

export default function swiper() {
  const slider = new Swiper('.news', {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 10,
    autoHeight: true,
    breakpoints: {
      // when window width is >= 1025px
      1025: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      // when window width is >= 769px
      769: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const slider2 = new Swiper('.data', {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 10,
    autoHeight: true,
    breakpoints: {
      // when window width is >= 1025px
      1025: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      // when window width is >= 769px
      769: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}


// WEBPACK FOOTER //
// ./scripts/modules/swiper.js